import { render } from "./Footer_page.vue?vue&type=template&id=0b863cde&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./Footer_page.vue?vue&type=script&lang=js"
export * from "./Footer_page.vue?vue&type=script&lang=js"

import "./Footer_page.vue?vue&type=style&index=0&id=0b863cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b863cde"]])

export default __exports__